<template>
    <Modal v-model="isShow" title="创建数据集" @on-ok="onOk" width="500">
        <Form v-if="config" :model="config" :label-width="80">
            <FormItem label="名称">
                <Input v-model="config.name" placeholder="输入名字"></Input>
            </FormItem>
            <FormItem label="依赖库">
                <Select v-model="selectedLibIndex" style="width:200px">
                    <Option  v-for="(lib, index) in extlibs" :value="index" :key="index">{{ lib.name }}</Option>
                </Select>
            </FormItem>
            <FormItem label="类型">
                <Select v-model="config.type" style="width:200px">
                    <template v-for="item in types">
                        <Option v-if="!format||!item.format||item.format===format" :value="item.name" :key="item.name">{{ item.title }}</Option>
                    </template>
                    <template v-if="loadedLib&&loadedLib.datasets">
                        <template  v-for="(datasetType) in loadedLib.datasets">
                            <Option v-if="!format||!item.format||item.format===format"  :value="loadedLib.id+'/'+datasetType.name" :key="loadedLib.id+'/'+datasetType.name">{{ loadedLib.name+'/'+datasetType.title }}</Option>    
                        </template>
                    </template>
                </Select>
            </FormItem>
        </Form>
    </Modal>
</template>
<script>
import * as extlibApi from '@/web/api/extlib';
import * as orginLib from '@/editor-components/lib-config/index';
import {normalizeUrl} from '@/web/lib/utils'
export default {
    props:["format"],
    data() {
        return {
            isShow:false,
            config:null,
            extlibs:[],
            selectedLibIndex:'',
            selectedDatasetType:null,
            loadedLib:null
        }
    },

    computed:{
        types(){
            return orginLib.datasets;
        }
    },

    watch: {
        selectedLibIndex(){
            this.importLib(normalizeUrl(this.extlibs[this.selectedLibIndex].path)+this.extlibs[this.selectedLibIndex].entryFileName).then((lib)=>{
                this.loadedLib =  lib.libConfig;
            });
        }
    },

    methods: {
        show(){
            this.config = {};
            this.isShow = true;
            this.getExtlibs();
        },

        onOk(){
            let [lib, type] = this.config.type.split('/');
            if(!type){
                type = lib;
                lib = 'de';
            }
            let typeObj;
            if(lib!=='de'){
                typeObj = this.extlibs[this.selectedLibIndex].datasets.find(ds=>ds.name===type);
            }else{
                typeObj = orginLib.datasets.find(ds=>ds.name===type);
            }
            
            this.config.config = JSON.stringify({format:typeObj.format});
            this.$emit('on-ok', this.config);
        },

        getExtlibs(){
            return extlibApi.getExtlibs().then((libs)=>{
                return this.extlibs = libs;
            })
        },

        importLib(entryFilePath){
            return new Promise((r,rj)=>{
                let lib = window.System.get(entryFilePath);
                if(lib){
                    r(lib.default);
                }else{
                    window.System.import(entryFilePath).then((lib,a,b,c)=>{
                    r(lib.default);
                    }).catch(e=>{
                        rj('加载库出错，请检查...');
                    });
                }
            })
        }
    },
}
</script>